import React from 'react';
import PropTypes from 'prop-types';
import { TextAreaType, RadioType, RadioGroupType, CheckboxType, AddressMapType, AddressType, TimeInputType, DndListType, MultiAddressList, DocumentsOfficials, DocumentsOfficialsOD, CommunitySiteAddress, ConnectUser, ConnectTpg, SequenceType, SequenceResume, SelectionListStops, SelectionListLineStops, MapAreaSelection,
// CategorizedResponses,
SequenceJourney, SelectionJourney, Calendar, Select, MapSimple, Slider, SelectionPolygon, Captcha, Email, Mode, CustomEnds, TimeClassic, EmailProInput } from "./types";
var Switcher = function Switcher(props) {
  var content = props.content,
    index = props.index,
    onChange = props.onChange,
    loop = props.loop;
  var expectedResponses = content.expectedResponses,
    type = content.type;
  var Type = null;
  switch (type.name) {
    case 'selection-list-stops':
      Type = SelectionListStops;
      break;
    case 'selection-list-line-stops':
      Type = SelectionListLineStops;
      break;
    case 'categorized-responses':
    case 'sequence':
      Type = SequenceType;
      break;
    case 'sequence-resume':
      Type = SequenceResume;
      break;
    case 'textarea':
      Type = TextAreaType;
      break;
    case 'checkbox':
      Type = CheckboxType;
      break;
    case 'radio':
      Type = RadioType;
      break;
    case 'radio-grouped':
      Type = RadioGroupType;
      break;
    case 'address-map':
      Type = AddressMapType;
      break;
    case 'address-community-site-map':
    case 'address-site-map':
    case 'address-site':
      Type = CommunitySiteAddress;
      break;
    case 'address':
      Type = AddressType;
      break;
    case 'time':
      Type = TimeInputType;
      break;
    case 'dnd-list':
    case 'dndlist':
      Type = DndListType;
      break;
    case 'multi-address-list':
    case 'multi-address':
      Type = MultiAddressList;
      break;
    case 'documents_officials':
      Type = DocumentsOfficials;
      break;
    case 'documents_officials_od':
      Type = DocumentsOfficialsOD;
      break;
    case 'connect':
    case 'connection':
    case 'connexion':
      Type = ConnectUser;
      break;
    case 'connect-tpg':
    case 'connecttpg':
    case 'connectTpg':
      Type = ConnectTpg;
      break;
    case 'map-area-selection':
      Type = MapAreaSelection;
      break;
    case 'selection-journey':
      Type = SelectionJourney;
      break;
    case 'calendar':
      Type = Calendar;
      break;
    case 'select':
      Type = Select;
      break;
    case 'map':
      Type = MapSimple;
      break;
    case 'slider':
      Type = Slider;
      break;
    case 'time-classic':
      Type = TimeClassic;
      break;
    case 'selection-list-polygon':
      Type = SelectionPolygon;
      break;
    case 'email':
      Type = Email;
      break;
    case 'captcha':
      Type = Captcha;
      break;
    case 'sequence-journey':
    case 'sequence_journey':
      Type = SequenceJourney;
      break;
    case 'mode':
      Type = Mode;
      break;
    case 'email_pro':
      Type = EmailProInput;
      break;
    case 'end_without_actions':
      Type = CustomEnds;
      break;
    default:
      return null;
  }
  return /*#__PURE__*/React.createElement(Type, {
    elements: expectedResponses,
    onChange: onChange,
    index: index,
    loop: loop
  });
};
Switcher.propTypes = {
  content: PropTypes.shape({}),
  onChange: PropTypes.func.isRequired,
  index: PropTypes.number
};
Switcher.defaultProps = {
  index: null,
  content: {}
};
export default Switcher;